import React from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import { TableType } from '@application/Types/ComponentTypes'
import { Nullable } from '@application/Types/Opt'
import { removeLineBreaksInTable } from '@src/Application/Utils/StringUtility'

import { TitleSection } from './Table.styled'

export const Table = ({ title, subtitle, tableDescription, mode, content }: TableType): Nullable<JSX.Element> => {
    return (
        <TitleSection title={title} subtitle={subtitle} description={tableDescription} mode={mode}>
            <Html mode={mode} content={removeLineBreaksInTable(content.data.childMarkdownRemark.html)}></Html>
        </TitleSection>
    )
}
